import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import Imgix from '../core/Imgix';

class Slider {
    constructor(el) {
        const imgixInstance = new Imgix(); // register new Imgix instance

        this.element = el
        this.imagesRequested = false
        this.swiper = null

        this.options = {
            modules: [Navigation, Pagination],
            loop: true,
            slidesPerView: 'auto',
            effect: "fade",
            centeredSlides: true,
            pagination: {
                el: '.swiper-pagination',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                slideChange: (swiper) => {
                    if (this.imagesRequested) return
                    // Load all images on first interaction
                    imgixInstance.process(swiper.el)
                    this.imagesRequested = true
                }
            },
            breakpoints: {
                1024: {
                  spaceBetween: 40
                },
            }
        }


        const classList = this.element.parentElement.classList;

        switch (true) {
            case classList.contains('c-slider--cards'):
                // add autoplay to existing modules
                // this.options.modules.push(Autoplay);

                // add new options
                Object.assign(this.options, {
                    modules: [Navigation, Pagination],
                    loop: false,
                    effect: null,
                    centeredSlides: false,
                    spaceBetween: 20,
                    pagination: {
                        el: ".swiper-pagination",
                        type: "progressbar",
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        1024: {
                          spaceBetween: 20
                        },
                    }
                });

                this.cardSlider(this.options);
                break;
            case classList.contains('c-slider--offers'):
                // add autoplay to existing modules
                // this.options.modules.push(Autoplay);

                // add new options
                Object.assign(this.options, {
                    modules: [Navigation, Pagination],
                    loop: false,
                    effect: null,
                    centeredSlides: false,
                    spaceBetween: 16,
                    pagination: {
                        el: ".swiper-pagination",
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        1024: {
                          spaceBetween: 40
                        },
                    }
                });

                this.cardSlider(this.options);
                break;

            default:

                this.defaultSlider(this.options);
                break;
        };
    }

    defaultSlider($options) {
        Swiper.use(Navigation)

        this.swiper = new Swiper(this.element, $options)
    }

    cardSlider($options) {
        Swiper.use(Navigation)

        this.swiper = new Swiper(this.element, $options);

        this.swiper.update();
    }
}

export default Slider
